import { z } from 'zod';
import { FileProps, SelectValueProps } from '../../types';

// ID type can be string or number
type ID = string | number;

export interface PlanInterface {
  id?: ID;
  name: string;
  description?: string;
  cover?: any;
  planType: string;
  visibility: string;
  code?: string;
  color?: string;
  coverUrl?: string;
  billingTriggerDay?: string | number;
  billingTriggerType?: string;
  cycles?: string | number;
  installments?: string | number;
  recurrence?: string;
  recurrenceValue?: string | number;
  status?: string;
  value?: string;
  planPrograms?: any[];
  externalPlans?: any[];
}

export const planFormSchema = z.object({
  name: z.string().min(1, 'Nome é obrigatório'),
  description: z.string().optional(),
  planType: z.string(),
  visibility: z.string(),
  color: z.string().optional(),
  coverUrl: z.string().optional(),
  billingTriggerType: z.string().optional(),
  billingTriggerDay: z.string().optional(),
  cycles: z.string().optional(),
  planPrograms: z.array(z.any()).optional(),
  externalPlans: z.array(z.any()).optional(),
  recurrence: z.string().optional(),
  recurrenceValue: z.string().optional(),
  value: z.string().optional(),
  installments: z.string().optional(),
});

export type PlanFormValues = z.infer<typeof planFormSchema>;

export interface PlanFormInfoProps {
  plan: PlanInterface;
  onPlanChange: (plan: Partial<PlanInterface>) => void;
  onImageUpload: (file: FileProps) => void;
}

export interface ColorValue {
  hex: string;
  rgba: string;
  r: number;
  g: number;
  b: number;
  a: number;
} 